import { createSelector } from '@reduxjs/toolkit';

import { name, NotificationsState } from '../reducers/notifications';

export const getNotificationsSlice = (state): NotificationsState => state[name];

export const notificationsListSelector = createSelector(
  [getNotificationsSlice],
  notifications => notifications.notifications
);

export const isLoadingNotificationsSelector = createSelector(
  [getNotificationsSlice],
  notifications => notifications.isFirstTimeLoading
);

export const notificationsListMetaSelector = createSelector(
  [getNotificationsSlice],
  notifications => notifications.notificationsListMeta
);

export const unreadCountSelector = createSelector(
  [notificationsListMetaSelector],
  notificationsMeta => notificationsMeta.unreadCount
);
